"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appShellInitialState = exports.storeName = void 0;
exports.storeName = 'appShell';
exports.appShellInitialState = {
    cmsBannerData: null,
    stateBannerData: null,
    AppFlowCode: {},
    analytics: {},
    analyticsEvent: {},
    baseURL: undefined,
    baseURLBB: {
        url: '',
    },
    baseURLDTV: {
        url: '',
    },
    baseURLDTVS: {
        url: '',
    },
    baseURLWLS: {
        url: '',
    },
    catalogResponse: undefined,
    'csrf-token': {},
    isTopPanelLoadedAlready: {},
    offerId: {
        offer: '',
    },
    pbData: {
        dueMonthly: 0,
        dueOneTime: 0,
        dueToday: 0,
        readyToCheckout: false,
    },
    priceBarUpdate: {
        dueMonthly: 0,
        dueOneTime: 0,
        dueToday: 0,
        readyToCheckout: false,
    },
    profile: {},
    submitOrder: {
        orderSubmitted: false,
    },
    submitOrderError: {
        orderSubmitError: false,
    },
};
//# sourceMappingURL=app-shell.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/common-ui/models/store/app-shell.model.js
// module id = 1424
// module chunks = 8